import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';
import { I18N_CONFIG } from '../../i18n/config';
import NotFoundPage from '../../pages/NotFoundPage';

const LanguageWrapper = ({ children }) => {
  const { i18n } = useTranslation();
  const { lang } = useParams();
  const isSupported = !lang || I18N_CONFIG.supportedLanguages.includes(lang);

  useEffect(() => {
    if (isSupported) {
      i18n.changeLanguage(lang || I18N_CONFIG.defaultLanguage);
    }
  }, [lang, isSupported, i18n]);

  // `/:lang` casa con CUALQUIER ruta de un segmento, así que este es el camino
  // por el que pasan las URLs inventadas tipo /cualquier-cosa. Antes redirigían
  // a la home, lo que las dejaba fuera del alcance de la ruta 404 y hacía que
  // Google viera el contenido de la home bajo esas URLs. Ahora devuelven el 404
  // (que va marcado noindex).
  if (!isSupported) {
    return <NotFoundPage />;
  }

  return children;
};

export default LanguageWrapper;
